<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addCustom" v-if="permissionCodes.indexOf('008002001') !== -1"/>
      </div>
      <input-search placeholder="场地名称" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @toCurrentPage="toCurrentPage" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该场地？'" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/SiteReservation";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "site-management",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧预约",
          name: "site-management"
        },
        {
          value: "场地管理"
        }
      ],
      addCustom: "site-add",
      tableHead: [
        {
          prop: "placeName",
          label: "场地名称"
        },
        {
          prop: "location",
          label: "场地位置"
        },
        {
          prop: "floorNameOnPage",
          label: "所在楼层"
        },
        {
          prop: "description",
          label: "场地描述"
        },
        {
          prop: "accessNames",
          label: "关联门禁"
        },
        {
          prop: "isFreeState",
          label: "是否收费"
        },
        {
          prop: "memo",
          label: "备注"
        },
        {
          prop: "responsiblePersonName",
          label: "责任人"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: "",
        customIntendType: ""
      },
      operationArr: ["current", "delete"]
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getPlacePage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              v.code = v.placeCode;
              if (v.isFree === 0) {
                v.isFreeState = "否";
              } else {
                v.isFreeState = "是";
              }
              if (v.payType === "0") {
                v.chargingStandard = "不收费";
              } else if (v.payType === "1") {
                v.chargingStandard = `${v.unitHour}元/时`;
              } else if (v.payType === "2") {
                v.chargingStandard = `${v.unitDay}元/天`;
              }
              if (v.buildingName && v.floorName) {
                v.floorNameOnPage = `${v.buildingName}/${v.floorName}`;
              } else {
                v.floorNameOnPage = "";
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取场地信息失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    deleteLine(code) {
      this.$axios
        .post(api.deletePlaceByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.getPage();
          }
        })
        .catch(errorHandler("删除人员信息失败"));
    },
    toCurrentPage(code) {
      this.$router.push({
        path: `/site_reservation/site_current/${code}`
      });
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/SiteReservation/SiteManagement/SiteManagement.vue